/*mitacode_custom.js*/

$(function(){

  // フラグチェック
  var flg = null;
  var check_access = function () {
    // ★sessionStorageの値を判定
    if (sessionStorage.getItem('access_flg')) {
      // 2回目以降
      flg = 1;
    } else {
      // 1回目
      sessionStorage.setItem('access_flg', true);
      flg = 0
    }
    return flg;
  }
  var $i = check_access();
  if($i == 0){
    // 1回目アクセスの処理
    // ローディング
    $(window).on('load',function(){
      $("#opening").delay(1500).fadeOut('slow');//ローディング画面を1.5秒（1500ms）待機してからフェードアウト
      $("#opening").delay(2500).each(function(){
        $(this).addClass(".openingBg");
      });
      $("#opening_logo").delay(1500).fadeOut('slow');//ロゴを1.2秒（1200ms）待機してからフェードアウト
    });
  
    function openingStart(){
      $('.opening_fade').addClass("openingScroll");
    }
    // 画面が読み込まれたらすぐに動かしたい場合の記述
    $(window).on('load', function(){
      openingStart();
    });
  }else{
    // 2回目アクセスの処理
    $(window).on('load',function(){
      $('#opening_logo').css('display','none');
      $("#opening").delay(50).fadeOut('slow');//ローディング画面を1.5秒（1500ms）待機してからフェードアウト
      $("#opening").delay(50).each(function(){
        $(this).addClass(".openingBg");
      });
    });
  
    function openingStart(){
      $('.opening_fade').addClass("openingScroll");
    }
    // 画面が読み込まれたらすぐに動かしたい場合の記述
    $(window).on('load', function(){
      openingStart();
    });
  }
    
  
  
    // スクロールでその場フェードイン
    $(window).scroll(function(){
      $('.fadeIn').each(function(){
        var elemPos = $(this).offset().top;
        var scroll = $(window).scrollTop();
        var windowHeight = $(window).height();
  
        if(scroll > elemPos - windowHeight + 50){
          $(this).addClass('scrollIn');
        }
      });
    });
  
    // スクロールで下からフェードイン
    $(window).scroll(function(){
      $('.fadeUp').each(function(){
        var elemPos = $(this).offset().top;
        var scroll = $(window).scrollTop();
        var windowHeight = $(window).height();
  
        if(scroll > elemPos - windowHeight + 70){
          $(this).addClass('scrollUp');
        }
      });
    });
  
    // スクロールで下からフェードイン その２
    $(window).scroll(function(){
      $('.fadeUp02').each(function(){
        var elemPos = $(this).offset().top;
        var scroll = $(window).scrollTop();
        var windowHeight = $(window).height();
  
        if(scroll > elemPos - windowHeight + 100){
          $(this).addClass('scrollUp02');
        }
      });
    });
  
    // スクロールで下からフェードイン その３
    $(window).scroll(function(){
      $('.fadeUp03').each(function(){
        var elemPos = $(this).offset().top;
        var scroll = $(window).scrollTop();
        var windowHeight = $(window).height();
  
        if(scroll > elemPos - windowHeight + 130){
          $(this).addClass('scrollUp03');
        }
      });
    });
  
    // スクロールで左からフェードイン
    $(window).scroll(function(){
      $('.fadeLeft').each(function(){
        var elemPos = $(this).offset().top;
        var scroll = $(window).scrollTop();
        var windowHeight = $(window).height();
  
        if(scroll > elemPos - windowHeight + 50){
          $(this).addClass('scrollLeft');
        }
      });
    });

    // スクロールで右からフェードイン
    $(window).scroll(function(){
      $('.fadeRight').each(function(){
        var elemPos = $(this).offset().top;
        var scroll = $(window).scrollTop();
        var windowHeight = $(window).height();
  
        if(scroll > elemPos - windowHeight + 50){
          $(this).addClass('scrollRight');
        }
      });
    });
  
  
    //スライダー
    $('.slider__list').slick({
      autoplay: false,
      autoplaySpeed: 3000,
      slidesToShow: 2,
      arrows: false,
      variableWidth: true,
      pauseOnHover: false,
    });


    $('.autoplay').slick({
      slidesToShow: 2,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 4000,
      responsive: [
        {
          breakpoint: 599, // 399px以下のサイズに適用
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });
  
  });
  
